import { IStore } from 'store/types';
import { IPayPeriods } from 'types';
import { IPayPeriodsKey } from './types';

export const selectPayPeriods =
  ({ orgId, siteId }: IPayPeriodsKey) =>
  (state: IStore): IPayPeriods | undefined =>
    state?.collections?.payPeriods?.[orgId]?.[siteId];
